import React, {useRef} from "react";
import UserSuggestionsDropdown from "../userSuggestion/index";
import borderImage from "../../../../assets/images/icons/buyers/border-buyers.svg"
import icon from "../../../../assets/images/icons/buyers/image-buyers.svg"

const BuyerForm = ({ 
  form, 
  newUser, 
  setNewUser, 
  userSuggestions, 
  searchUsers, 
  setUserSuggestions,
  onImageError 
}) => {

const [emailError, setEmailError] = React.useState('');
const [phoneError, setPhoneError] = React.useState('');
const [nameError, setNameError] = React.useState('');
const [chargeError, setChargeError] = React.useState('');

  const fileInputRef = useRef(null);
  const formKey = `${form.x}-${form.y}`; 

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/svg+xml'];
      
      if (!validImageTypes.includes(file.type)) {
        if (onImageError) {
          onImageError("Por favor, selecciona un archivo de imagen válido (JPG, JPEG, PNG, WEBP o SVG)");
        }
        e.target.value = '';
        return;
      }

      if (file.size > 50 * 1024 * 1024) {
        if (onImageError) {
          onImageError("La imagen no debe superar los 50MB");
        }
        e.target.value = '';
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setNewUser(prev => ({
          ...prev,
          [formKey]: {
            ...prev[formKey],
            image: reader.result
          }
        }));
      };
      reader.onerror = () => {
        if (onImageError) {
          onImageError("Error al leer el archivo de imagen");
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  return (
    
    <div key={`form-${form.x}-${form.y}`} className="flex items-center h-[310px] justify-center w-full">
        <div className="flex flex-col items-center justify-between p-3 w-[80%] h-full gap-1">
            <div className="relative flex items-center justify-center">
                <img src={borderImage} alt="Borde" className="w-[101px] h-[101px]" />
                <div className="absolute inset-0 flex items-center justify-center">
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleImageChange}
                        accept=".jpg,.jpeg,.png,.webp,.svg,image/jpeg,image/jpg,image/png,image/webp,image/svg+xml"
                        className="hidden"
                    />
                    {newUser[formKey]?.image ? (
                      <img 
                        src={newUser[formKey].image} 
                        alt="Foto de perfil" 
                        className="w-[80px] rounded-full h-[80px] object-cover cursor-pointer"
                        onClick={triggerFileInput}
                      />
                    ) : (
                      <img 
                        src={icon} 
                        alt="Icono por defecto" 
                        className="w-[80px] rounded-full h-[80px] cursor-pointer"
                        onClick={triggerFileInput}
                      />
                    )}
                </div>
            </div>
            <div className="relative w-full">
                <input
                type="text"
                placeholder="Nombre completo *"
                className={`rounded-lg w-full outline-none h-[35px] border-[1px] p-2 font-itcdemi text-base text-center ${
                  nameError ? 'border-red-500' : 'border-[#6B7280]'
                } bg-transparent`}
                value={newUser[formKey]?.name || ''}
                onChange={(e) => {
                    const valueWithoutNumbers = e.target.value.replace(/[0-9]/g, '');
                    const limitedValue = valueWithoutNumbers.slice(0, 50);

                    setNewUser(prev => ({
                      ...prev,
                      [formKey]: {...prev[formKey], name: limitedValue}
                    }));

                    if (limitedValue.length > 50) {
                      setNameError('El nombre no puede exceder los 50 caracteres');
                    } else if (limitedValue.length === 0) {
                      setNameError('');
                    } else if (limitedValue.length > 0 && limitedValue.length <= 50) {
                      setNameError('');
                    }

                    searchUsers(valueWithoutNumbers, formKey);
                }}
                onKeyDown={(e) => {
                  if (/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                maxLength={50}
                />
                {nameError && (
                  <p className="text-[10px] text-center text-red-500 font-itcbook mt-1">
                    {nameError}
                  </p>
                )}
                {userSuggestions[formKey]?.length > 0 && (
                <UserSuggestionsDropdown
                    suggestions={userSuggestions[formKey]}
                    onSelectUser={(user) => {
                    setNewUser(prev => ({
                      ...prev,
                      [formKey]: { 
                        ...prev[formKey], 
                        ...user, 
                        x_position: form.x,
                        y_position: form.y
                      }
                    }));
                    setUserSuggestions(prev => ({...prev, [formKey]: []}));
                    setNameError('');
                    }}
                    onClose={() => setUserSuggestions(prev => ({...prev, [formKey]: []}))}
                />
                )}
            </div>
            <input
                type="text"
                placeholder="Cargo"
                className={`rounded-lg h-[35px] outline-none w-full border-[1px] p-2 font-itcbook text-base text-center ${
                  chargeError ? 'border-red-500' : 'border-[#6B7280]'
                } bg-transparent`}
                value={newUser[formKey]?.charge || ''}
                onChange={(e) => {
                  const valueWithoutNumbers = e.target.value.replace(/[0-9]/g, '');
                  const limitedValue = valueWithoutNumbers.slice(0, 50);

                  setNewUser(prev => ({
                      ...prev,
                      [formKey]: {...prev[formKey], charge: valueWithoutNumbers}
                  }));

                  if (limitedValue.length > 50) {
                    setChargeError('El cargo no puede exceder los 50 caracteres');
                  } else if (limitedValue.length === 0) {
                    setChargeError('');
                  } else if (limitedValue.length > 0 && limitedValue.length <= 50) {
                    setChargeError('');
                  }
                }}
                onKeyDown={(e) => {
                  if (/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                maxLength={50}
            />
            {chargeError && (
              <p className="text-[10px] text-center text-red-500 font-itcbook">
                {chargeError}
              </p>
            )}
            <input
              type="text"
              inputMode="numeric"
              placeholder="Número de contacto"
              className={`rounded-lg w-full outline-none h-[35px] border-[1px] p-2 font-itcbook text-base text-center ${
                phoneError ? 'border-red-500' : 'border-[#6B7280]'
              } bg-transparent`}
              value={newUser[formKey]?.contact_number || ''}
              onChange={(e) => {
                let value = e.target.value.replace(/\D/g, '');
                
                if (value.startsWith('0')) {
                  value = value.substring(1);
                }
                
                value = value.slice(0, 9);
                
                setNewUser(prev => ({
                  ...prev,
                  [formKey]: { ...prev[formKey], contact_number: value }
                }));
                
                if (value.length === 0) {
                  setPhoneError('');
                } else if (value.length !== 9) {
                  setPhoneError('El número debe tener exactamente 9 dígitos');
                } else {
                  setPhoneError('');
                }
              }}
              onKeyDown={(e) => {
                if (!/\d/.test(e.key) && 
                    !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              minLength={9}
              maxLength={9}
            />
            {phoneError && (
              <p className="text-[10px] text-center text-red-500 font-itcbook">
                {phoneError}
              </p>
            )}
            <input
              type="email"
              placeholder="Correo electrónico *"
              className={`rounded-lg w-full outline-none h-[35px] border-[1px] p-2 font-itcbook text-base text-center ${
                emailError ? 'border-red-500' : 'border-[#6B7280]'
              } bg-transparent`}
              value={newUser[formKey]?.email || ''}
              onChange={(e) => {
                const value = e.target.value.trim();
                const limitedValue = value.slice(0, 200);

                setNewUser((prev) => ({
                  ...prev,
                  [formKey]: { ...prev[formKey], email: value },
                }));

                if (limitedValue === '') {
                  setEmailError('');
                } else if (limitedValue.length > 200) {
                  setEmailError('El correo no puede exceder los 200 caracteres');
                } else if (!/^[A-Za-z0-9._%+-]+@tasa\.com\.pe$/i.test(limitedValue)) {
                  setEmailError('Solo se permiten correos con dominio @tasa.com.pe');
                } else {
                  setEmailError('');
                }
              }}
              maxLength={50}
            />
            {emailError && (
              <p className="text-[10px] text-center text-red-500 font-itcbook">
                {emailError}
              </p>
            )}
        </div>
    </div>

  );
};

export default BuyerForm;